/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { BodyText, Heading, ProgressBar, Size, Stack } from '@vaisala/rockhopper-components';

import * as React from 'react';
import styled from 'styled-components';

const ProgressContainer = styled(Stack)`

  position : relative;
  width : 100%;
  height : 100%;

  .progress-label {
    min-width : 250px;
  }

  .progress-bar {
    width : 50%;
    margin : 0;
  }

  .vai-progress-bar__animation {
    height : 5px;
  }
`



interface Props {
  main_label : string,
  main_progress : number,
  secondary_label : string,
  secondary_progress : number,
  increment : string
}

export const Progress : React.FC<Props> = ( props) => {

  const {
    main_label,
    main_progress,
    secondary_label,
    secondary_progress,
    increment
  } = props

  return (
    <ProgressContainer direction='row' justify='space-between' align='center'>
      <Heading level={2} className="vai-margin-top-none progress-label">
        {main_label + " progress..."}
      </Heading>
      <div style={{width : '80%'}}>
      <Stack justify='space-around' align='center' spacing={Size.None}>
        <div className='progress-bar'>
          <ProgressBar progress={main_progress <= 0.01 ? 0.01 : main_progress} label={main_progress <= 0.01 ? `${main_label} : 1%` : `${main_label} : ${(main_progress * 100).toFixed(0)}%`} />
        </div>
        <div className='progress-bar'>
          <ProgressBar progress={secondary_progress <= 0.01  ? 0.01 : secondary_progress} label={secondary_progress <= 0.01 ? `${secondary_label} : 1%` : `${secondary_label} : ${(secondary_progress * 100).toFixed(0)}%`} />
        </div>
        <div className='progress-bar'>
          <BodyText style={{margin : 0}}>
            {"Currently processing " + increment}
          </BodyText>
        </div>
      </Stack>
    </div>
    </ProgressContainer>
  );
};
